import React from 'react';
import { ColumnsType } from 'antd/es/table';
import { ProcessingFacilityTableProps } from 'enums/ProcessingFacilityEnums';
import stringComparator from 'shared/utils/stringComparator';

interface DataType {
  id: React.Key;
  processingFacility: string;
  scope1: number;
  scope2: number;
  total: number;
  name: string;
}

export const getColumns = (): ColumnsType<DataType> => {
  return [
    {
      title: ProcessingFacilityTableProps.PROCESSING_FACILITY_TITLE,
      dataIndex: ProcessingFacilityTableProps.PROCESSING_FACILITY_INDEX,
      defaultSortOrder:
        ProcessingFacilityTableProps.PROCESSING_FACILITY_SORT_ORDER,
      sorter: (a, b) => stringComparator(a.name, b.name),
    },
    {
      title: <p>{ProcessingFacilityTableProps.SCOPE1_TITLE1}</p>,
      dataIndex: ProcessingFacilityTableProps.SCOPE1_INDEX,
      defaultSortOrder:
        ProcessingFacilityTableProps.PROCESSING_FACILITY_SORT_ORDER,
      sorter: (a, b) => a.scope1 - b.scope1,
    },
    {
      title: <p>{ProcessingFacilityTableProps.SCOPE2_TITLE1}</p>,
      dataIndex: ProcessingFacilityTableProps.SCOPE2_INDEX,
      defaultSortOrder: ProcessingFacilityTableProps.SCOPE2_SORT_ORDER,
      sorter: (a, b) => a.scope2 - b.scope2,
    },
    {
      title: <p>{ProcessingFacilityTableProps.TOTAL_TITLE1}</p>,
      dataIndex: ProcessingFacilityTableProps.TOTAL_INDEX,
      defaultSortOrder: ProcessingFacilityTableProps.TOTAL_SORT_ORDER,
      sorter: (a, b) => a.total - b.total,
    },
  ];
};
